import React from "react";
import "./PartnerCompanies.css";
import Nav from "../Navbar/Navbar";       
import Footer from "../Footer/Footer"; 

const PartnerCompanies = () => {
  const companies = [
    "IQVenus",
    "IQPonics",
    "IQMingsen",
    "Krissnika Technical",
    "AizalIQ",
    "Agomoni",
  ];

  return (
    <>
      <Nav />
      <section className="partner-section">
        <h2 className="partner-title">Esteemed Partner Companies</h2>
        <div className="partner-list">
          {companies.map((company, index) => (
            <div key={index} className="partner-card">
              {company}
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PartnerCompanies;
